export enum ContentType {
  None = "None",
  Draft = "Draft",
  Published = "Published",
  CategoryImageDraft = "CategoryImageDraft",
  CategoryImagePublished = "CategoryImagePublished",
  RelatedDocumentDraft = "RelatedDocumentDraft",
  RelatedDocumentPublished = "RelatedDocumentPublished",
  IncludeIndividualPartDraft = "IncludeIndividualPartDraft",
  IncludeIndividualPartPublished = "IncludeIndividualPartPublished",
  ExcludeIndividualPartDraft = "ExcludeIndividualPartDraft",
  ExcludeIndividualPartPublished = "ExcludeIndividualPartPublished",
  PicCodeDraft = "PicCodeDraft",
  PicCodePublished = "PicCodePublished",
  SpecDraft = "SpecDraft",
  SpecPublished = "SpecPublished",
  MarketingTextDraft = "MarketingTextDraft",
  MarketingTextPublished = "MarketingTextPublished",
  SeeAlsoDraft = "SeeAlsoDraft",
  SeeAlsoPublished = "SeeAlsoPublished",
  KitDraft = "KitDraft",
  KitPublished = "KitPublished"
}
